import { Component, OnInit } from '@angular/core';

/**
 * Component:
 * Loader component displaying a spinner element;
 */

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.css']
})
export class LoaderComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
